import { Auth, Permissions } from '@revolut-internal/idave-web-auth'

import { API_URL } from '../shared/consts'

const isProd = window.location.hostname.endsWith('.com')

export const IDAVE_HOST = isProd ? 'https://id.revolut.com' : 'https://id.revolut.codes'

export const IDAVE_CLIENT_ID = isProd
  ? 'not-created-yet'
  : '130185b7-6b4f-4cf3-a734-214e69d76c9d'

export const auth = new Auth({
  iDaveClientId: IDAVE_CLIENT_ID,
  iDaveHost: IDAVE_HOST,
  apiUrl: API_URL,
  loginUrl: '/idave/oauth2/code',
})

export const permissions = new Permissions({
  servicesApiMap: {
    rmail: API_URL,
  },
})
